import { createAction } from "redux-actions";

export const setFiltersAsset = createAction("FILTERS_SETTINGS/SET_ASSET");

export const deletePreset = createAction("FILTERS_SETTINGS/DELETE_PRESET");
export const changePreset = createAction("FILTERS_SETTINGS/CHANGE_PRESET");
export const setPresetError = createAction("FILTERS_SETTINGS/SET_PRESET_ERROR");
